<!-- 产业嘉宾名录 -->
<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">产业嘉宾名录</div>
    </div>

    <div class="center-pc tb">
      <div class="position-r">
        <ul class="type-nav">
          <template v-for="(item, index) in gusetTypeOp">
            <li
              :key="`li_${item.type}`"
              :class="navType == item.type ? 'active' : ''"
              @click="changeType(item.type)"
            >
              {{ item.name }}
            </li>
            <span :key="item.type" v-if="index != gusetTypeOp.length - 1">|</span>
          </template>
        </ul>

        <input v-model="guestAuthKey" class="tb-input" placeholder="关键词（按Enter键查询）" @keyup.enter="getList" />
      </div>

      <table class="simple-tb">
        <tr class="th">
          <td style="width: 20%">姓名</td>
          <td style="width: 20%">电话号码</td>
          <td style="width: 30%">邮箱</td>
          <td style="width: 30%">公司/机构名称</td>
        </tr>
        <tr
          v-for="(item, index) in guestList"
          :key="index"
        >
          <td>{{ item.guestName }}</td>
          <td>{{ item.talkMobile }}</td>
          <td>{{ item.talkEmail }}</td>
          <td>{{ item.company }}</td>
        </tr>
        <tr v-if="guestList.length == 0">
          <td class="text-gray" colspan="4">暂无数据</td>
        </tr>
      </table>
    </div>

    <div class="foo foo-center border-no">
      <button class="leftBtn" @click="goBack">返回</button>
    </div>
  </div>
</template>

<script>
import  { industryApi } from '@/api/industry'

export default {
  data() {
    return {
      gusetTypeOp: [{
        type: '10',
        name: '创投嘉宾'
      }, {
        type: '13',
        name: '市场嘉宾'
      }],
      navType: '10',
      guestAuthKey: '',
      guestList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let params = {
        page: {
          pageNum: 1,
          pageSize: 9999
        },
        mainId: this.$session.get("cmm").mainId,
        guestType: this.navType,
        guestAuthKey: this.guestAuthKey
      }
      industryApi.getAuthList(params).then(res => {
        if (res && res.code == 200) {
          this.guestList = [].concat(res.data.result)
        }
      })
    },
    changeType(type) {
      this.guestAuthKey = ''
      this.navType = type
      this.getList()
    },
    goBack() {
      this.$router.push("/userIndex")
    }
  }
}
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>